import styles from './header.module.css';
import { useEffect } from 'react';
import { useRef } from 'react';
import gsap from 'gsap';
import DOMPurify from 'dompurify';
import VideoAlert from '../../video-alert';

// 参考 iPhone 14 Pro 的最开始直接播放出来然后出现产品名称
const Header = ({ textData, language, isWeiXin }) => {
  const canvasRef = useRef(null);
  const ctnRef = useRef(null);
  const text1Ref = useRef(null);
  const text2Ref = useRef(null);
  const text3Ref = useRef(null);
  const textProductRef = useRef(null);
  const textBoxRef = useRef(null);

  useEffect(() => {
    new VideoAlert({
      havePathElement: `.${styles.watchVideo}`,
    });
  }, []);

  useEffect(() => {
    if(isWeiXin) {
      document.querySelector('body').classList.add('end-pin');
    }
  },[])

  // useEffect(() => {
  //   disinfectAnimation();
  // }, []);
  return (
    <div className={styles.ctn} ref={ctnRef}>
      <div className={styles.videoBox}>
        <div className={styles.mask}></div>
        <video
          autoPlay
          playsInline
          muted
          preload="true"
          src="https://bucket.zhiyun-tech.com/detail/ozone-sterilizer/zhiyunlife-ozone-video-header.mp4"
          poster='https://bucket.zhiyun-tech.com/detail/ozone-sterilizer/zhiyunlife-ozone-video-header-cover.jpg'
          className={styles.video}
          onCanPlay={(e) => {
            if (!isWeiXin) {
              e.target.classList.add('active');
              e.target.playbackRate = 1.5;

              setTimeout(() => {
                document.querySelector('body').classList.add('end-pin');
              }, 1500);

              textBoxRef.current.classList.add('active');
            }
          }}
        ></video>

        <div className={styles.textBox} ref={textBoxRef}>
          <div>
            <h4
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text1']),
              }}
            ></h4>
            <h1
              className={`${styles.textProduct} ${styles.text}`}
              ref={textProductRef}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text2']),
              }}
            ></h1>
          </div>

          <button
            className={styles.watchVideo}
            data-video-src={`https://bucket.zhiyun-tech.com/detail/ozone-sterilizer/zhiyunlife-ozone-tvc-${
              language === 'cn' ? 'cn' : 'en'
            }.mp4`}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 14.1783V3.82167C5 3.03258 5.87115 2.55437 6.53688 2.97801L14.6742 8.15634C15.2917 8.54929 15.2917 9.45071 14.6742 9.84366L6.53688 15.022C5.87115 15.4456 5 14.9674 5 14.1783Z"
                fill="#FF6B4D"
              />
            </svg>

            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(textData['text3']),
              }}
            ></div>
          </button>
        </div>
      </div>

      <h4
        className={styles.overview}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text4']),
        }}
      ></h4>
    </div>
  );
};

export default Header;
